import Vue from "vue";
import App from "./App.vue";

import svg4everybody from "svg4everybody";
import objectFitImages from "object-fit-images";
import AOS from "aos";

import "@/assets/style.scss";
import "swiper/dist/css/swiper.css";
import "aos/dist/aos.css";
// ..

Vue.config.productionTip = false;

const AOSOptions = {
  once: true,
  duration: 1000,
  offset: 0
};

svg4everybody();
objectFitImages();
AOS.init(AOSOptions);

new Vue({
  render: h => h(App)
}).$mount("#app");
